import { render } from "./BookingLayout.vue?vue&type=template&id=21b7639c"
const script = {}

import "./BookingLayout.vue?vue&type=style&index=0&id=21b7639c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__